const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';
const ARABIC_INDIC_DIGITS = '٠١٢٣٤٥٦٧٨٩';

/** Converts Persian (۰-۹) and Arabic-Indic (٠-٩) digits to Latin digits (BR-21). */
export function toLatinDigits(value: string): string {
  return value
    .replace(/[۰-۹]/g, (c) => String(PERSIAN_DIGITS.indexOf(c)))
    .replace(/[٠-٩]/g, (c) => String(ARABIC_INDIC_DIGITS.indexOf(c)));
}

/** Converts Latin digits to Persian digits for display (BR-21). */
export function toPersianDigits(value: string | number | bigint): string {
  return String(value).replace(/[0-9]/g, (c) => PERSIAN_DIGITS[Number(c)] as string);
}

/**
 * Groups the digits of a free-form numeric input with a thousands separator (BR-02).
 * Non-digit characters are dropped. Returns '' when there are no digits.
 */
export function groupDigits(value: string): string {
  const raw = toLatinDigits(value).replace(/[^0-9]/g, '');
  if (!raw) return '';
  return raw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
